import { withInstall } from '@xzx-design/utils'
import _Form from './src/form'

export const Form = withInstall(_Form)
export default Form

export * from './src/form'
